import { Flex } from 'foundations-components/components/Flex';
import FeatureTile from './FeatureTile';
import { jsx as _jsx } from "react/jsx-runtime";
const FeatureSurveyRow = ({
  features,
  onSelectionChange
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "800",
    flexWrap: "wrap",
    children: features.map(surveyFeature => {
      return /*#__PURE__*/_jsx(FeatureTile, {
        feature: surveyFeature,
        onSelectionChange: onSelectionChange
      }, surveyFeature.featureKey);
    })
  });
};
export default FeatureSurveyRow;